import { render, staticRenderFns } from "./enterpriseCommodity.vue?vue&type=template&id=4b1af0c0&scoped=true&"
import script from "./enterpriseCommodity.vue?vue&type=script&lang=js&"
export * from "./enterpriseCommodity.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseCommodity.vue?vue&type=style&index=0&id=4b1af0c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1af0c0",
  null
  
)

export default component.exports